import useMutation from 'hooks/use-mutation';
import useCurrentSurface from 'routes/surface/hooks/use-current-surface';
import { useTranslation } from 'i18n';
import { deleteInvitationOnSurfaceMutation } from 'graphql/user/mutations/delete-user-invitation-on-surface';
import { fetchUsersWithAccessToSurfaceQuery } from 'graphql/user/queries/fetch-users-with-access-to-surface';
import { surfaceHierarchyQuery } from 'graphql/surface/queries/surface-hierarchy';
import toast from 'services/toast';

export default function useDeleteUserInvitationOnSurface() {
  const { t } = useTranslation();
  const surface = useCurrentSurface();

  const [deleteInvitationOnSurface] = useMutation(
    deleteInvitationOnSurfaceMutation,
    {
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: fetchUsersWithAccessToSurfaceQuery,
          variables: { surface: surface?.id },
        },
        {
          query: surfaceHierarchyQuery,
          variables: { input: { surface: surface?.id } },
        },
      ],
    },
  );

  return function (invitation: any) {
    return deleteInvitationOnSurface({ variables: { id: invitation.id } }).then(
      (response) => {
        if (response.isFailure) {
          return toast.error(response.getErrorMessage());
        }

        return toast.success(
          t('Successfully deleted invitation for {{email}}', {
            replace: { email: invitation.email },
          }),
        );
      },
    );
  };
}
